import { render, staticRenderFns } from "./receiveOrderLog.vue?vue&type=template&id=c015a16a&scoped=true&"
import script from "./receiveOrderLog.vue?vue&type=script&lang=js&"
export * from "./receiveOrderLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c015a16a",
  null
  
)

export default component.exports